import classNames from "classnames";
import { Divider } from "components/design/Divider";
import Loader from "components/DesignSystem/Loader/loader";
import { Button } from "components/DesignSystem/Button/Button";
import { CaretDown } from "components/icons/CaretDown";
import { BRAND_CREATION_PROCEED } from "constants/analyticsEvents";
import { useAnalytics } from "hooks/useAnalytics";
import { useRoleBasedView } from "hooks/useRoleBasedView";
import { useEffect, useState } from "react";
import DomainRecognize from "signInSignUp/domainRecognize";
import { useGetDomainRecognizationQuery } from "store/apis/serviceTeam";

export const BrandOption = ({
  setCreateBrand,
  handleGoBack,
}: {
  setCreateBrand: (val: boolean) => void;
  handleGoBack: () => void;
}) => {
  const [isCreateGroup, setCreateGroup] = useState(false);
  const [joinRequest, setjoinRequest] = useState(false);
  const { trackEvent } = useAnalytics();
  const { isUserTypeForeignCA, isForeignCA } = useRoleBasedView();
  const {
    data: groupData = [],
    isLoading,
    isSuccess,
  } = useGetDomainRecognizationQuery();

  useEffect(() => {
    if (isSuccess && groupData.length === 0) {
      setCreateBrand(true);
      setCreateGroup(true);
    }
  }, [groupData, isSuccess]);

  const startCreateBrand = () => {
    trackEvent(BRAND_CREATION_PROCEED, {});
    setCreateBrand(true);
  };

  if (isLoading) {
    return <Loader />;
  }

  const showProceed = isUserTypeForeignCA ? groupData.length === 0 : true;

  return (
    <div
      className={classNames(
        "!t-h-full !t-pt-0 t-w-full t-overflow-auto t-mt-[72px]",
        {
          overflowDiv: !isCreateGroup,
        }
      )}
    >
      {showProceed && (
        <>
          <div>
            <p className="rightContainerTitle !t-my-0 !t-text-subtext !t-text-text-100">
              {isUserTypeForeignCA
                ? "Want to create a new organisation?"
                : "Create a new brand"}
            </p>
            <p className="rightContainerSubTitle !t-text-body-sm t-text-neutral t-mt-3 t-mb-6">
              {isUserTypeForeignCA
                ? "Sign up using a different mail"
                : "Proceed to create a new brand if this email is not part of any existing setup on Inkle."}
            </p>
            <Button
              customType="primary"
              size="large"
              block
              onClick={startCreateBrand}
            >
              Create a new brand
            </Button>
          </div>
          <div className="t-flex t-items-center t-justify-between t-gap-2 t-py-[30px]">
            <Divider classNames="t-w-full" />
            <span className="t-text-body-sm t-text-text-30">or</span>
            <Divider classNames="t-w-full" />
          </div>
        </>
      )}

      {!isCreateGroup && (
        <div>
          <div className="t-mt-1 t-space-y-2">
            <div className="t-text-subtext t-text-text-100">
              {isUserTypeForeignCA || isForeignCA
                ? "Join an organisation"
                : "Join an existing brand"}
            </div>
            <div className="existingGroup !t-text-body-sm !t-leading-6 t-text-neutral !t-mt-2 t-pb-4">
              {isUserTypeForeignCA || isForeignCA
                ? "There is an existing practice created by your team members. Would you like to join it?"
                : "We found brand(s) linked to this email domain. You can request access to join your team."}
            </div>
          </div>
          <DomainRecognize
            groups={groupData}
            setCreateGroup={setCreateGroup}
            setjoinRequest={setjoinRequest}
            joinRequest={joinRequest}
          />
        </div>
      )}
      <div className="t-flex-shrink-0 t-mt-auto t-flex t-justify-between t-pt-6 t-pb-20">
        <Button
          onClick={handleGoBack}
          customType="link"
          type="button"
          size="small"
        >
          <CaretDown className="t-rotate-90 t-mr-1" /> Go back
        </Button>
      </div>
    </div>
  );
};
